import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";

export const TopLevelDomainsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListTopLevelDomains') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes('CreateTopLevelDomain') ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/top-level-domains'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetTopLevelDomain') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/top-level-domains'/>
                    )
                }
            />
        </Routes>
    );
};
